import React from 'react';
import { getNonprofitIcon } from '../utils/nonprofitIcons';

function isImageSrc(icon) {
  return typeof icon === 'string' && (
    icon.startsWith('data:image/') ||
    icon.startsWith('https://') ||
    icon.startsWith('http://') ||
    icon.startsWith('blob:')
  );
}

function CustomLinkIcon({ icon, alt = '', className, style }) {
  const preset = getNonprofitIcon(icon);
  if (preset?.Icon) {
    const Icon = preset.Icon;
    return (
      <Icon
        className={className}
        title={alt || preset.label}
        aria-hidden={alt ? undefined : true}
        style={{ color: preset.color, ...style }}
      />
    );
  }
  if (isImageSrc(icon)) {
    return <img src={icon} alt={alt} className={className} style={style} />;
  }
  return null;
}

export default CustomLinkIcon;
